import React, { useState } from "react";

const SwitcherNoText = ({
  isChecked,
  setIsChecked,
  activeText,
  inactiveText,
}) => {


  return (
    <label
      className={`switcher switcher--${
        isChecked ?  "service" : "disabled"
      }`}
    >
      <input
        type="checkbox"
        name="checkbox"
        checked={isChecked}
        onChange={(e) => setIsChecked(e.target.checked)}
      />
      <span
        className={`switcher__label is-${isChecked ? "checked" : "unchecked"}`}
      >
        {isChecked ? activeText : inactiveText}
      </span>
      <span className="switcher__back"></span>
    </label>
  );
};

export default SwitcherNoText;
